import { render, staticRenderFns } from "./Type3_Devices.vue?vue&type=template&id=797b4967&"
import script from "./Type3_Devices.vue?vue&type=script&lang=js&"
export * from "./Type3_Devices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports